import React, { useState } from "react";
import { Project } from "../objects/Project.interface";
import { ProjectsService } from "../services/Projects.service";

import { Button, Dialog, DialogActions, DialogContent, DialogTitle, DialogContentText, IconButton, TextField, TextareaAutosize, Box, Tabs, Tab } from "@mui/material";
import { DataGrid, useGridApiRef,GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { Document } from "../objects/Document.interface";
import { DocumentService } from "../services/Documents.service";
import Details from "./EntityDetails";
import { Entity } from "../objects/Entity.interface";
import { createNewEntity, EntitiesService } from "../services/Entities.service";
import { getEntityCode } from "../tools/Utils";
import { ExportData } from "../tools/ExportData";
import { NewEntity, ParseEntitiesJSON, ReadFileToText } from "../tools/FileReader";
import { AnnotationService } from "../services/Annotations.service";
import { FileParser } from "../tools/FileParser";




export type ProjectDetailsProps = {
    Project:Project,
    backProjectsScreen: () => void,
    openDashboard: (project:Project) => void
}

var enc = new TextEncoder(); // always utf-8
var documentSelected: Document = {
    id: 0,
    title: "",
    textContent: enc.encode(""),
    projectId: 0,
    isSelected: false,
    sort: 0,
    placeNames: []
};

var entitySelectedTmp: Entity = createNewEntity();


var documentsList: Document[] = [];
var entityListTmp: Entity[] = [];

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
  }
  
  function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
      </div>
    );
  }
  
  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

export default function ProjectDetails (props:ProjectDetailsProps)  {
    const projectService = new ProjectsService();
    const documentService =  new DocumentService();
    const entityService = new EntitiesService();
    const annotationService = new AnnotationService();
    const exportService: ExportData = new ExportData();
    const parseFileService: FileParser = new FileParser();


    var projectSelected: Project = props.Project;
    

    

    //Cambios de paginas de detalles de pojecto y de entidad
    const [page, setPage] = useState("projectDetails");
    const [entitySelected, setEntitySelected] = useState(entitySelectedTmp);
    const [entityList, setEntityList] = useState(entityListTmp);
   
    
    const [requestStatus, setRequestStatus] = useState(false); //maneja la actualizacion de los documentos (la primera vez y cuando uno es borrado)
    const [requestEntityStatus, setRequestEntityStatus] = useState(false); //maneja la actualizacion de los documentos (la primera vez y cuando uno es borrado)
    const [value, setValue] = React.useState(0); //maneja el valor del tab que es cambiado
    
    const handleLoadDocuments = ()=>{
        const documentRequest =  documentService.getList(projectSelected.id!);
        documentRequest.then(result => {
            //para solo consultar una vez
            setRequestStatus(true);
            setDocuments(result);            
        });
    }

    if(!requestEntityStatus){
        var result = entityService.getList(projectSelected.id!);
        result.then(res =>
            {
                setRequestEntityStatus(true);
                const allEntities = res? (res as Entity[]): ([] as Entity[]); 
                if(allEntities.length > 0)
                    setEntitySelected(allEntities[0]);
                setEntityList(allEntities);
                
            });
    }
    
    if(!requestStatus){
        handleLoadDocuments();  
    }

   const [name, setName] = useState(props.Project.name);
   const [description, setDescription] = useState(props.Project.description);
   //document list
   const [open, setOpen] = React.useState(false);
   const [documentToDelete, setDocumentToDelete] = useState(documentSelected);
   const [documents, setDocuments] = useState(documentsList);
   const apiRef = useGridApiRef();
   const columns: GridColDef[] = [
    {field: 'id'},
    {field: 'title', flex: 1, minWidth: 200, maxWidth:700},
    {field: 'Actions', flex: 0.3, minWidth: 200,
        renderCell: (params: GridRenderCellParams<any, number>) => 
        (
            <div>
                
                
                <IconButton aria-label="Delete Document" size="small" color="error" onClick={()=>{ var result:Document|undefined = documents.find((document) => document.id == params.id);
                    if(result){
                        setDocumentToDelete(result);
                        setOpen(true);
                    }
                }}>
                    <DeleteIcon fontSize="inherit" />
                </IconButton>
            </div>
        )}
];
//entity list
const [openDialog, setOpenDialog] = React.useState(false);
const apiEntityRef = useGridApiRef();
const entityColumns: GridColDef[] = [
    {field: 'id', maxWidth: 0, width: 1},
    {field: 'Namespace', minWidth: 100},
    {field: 'Code', minWidth: 100},
    {field: 'Entity', flex: 1, minWidth: 200},
    {field: 'Color', minWidth: 100,
        renderCell: (params: GridRenderCellParams<any, string>) => 
        (
            <div className="area-entity-rectangle" style={{background: params.value}}></div>
        )
    },
    {field: 'Fields', minWidth: 100},
    {field: 'Actions', flex: 0.3, minWidth: 200,
        renderCell: (params: GridRenderCellParams<any, number>) => 
        (
            <div>
                 
            
                <IconButton aria-label="Edit" size="small" color="inherit" onClick={()=>{ var result:Entity|undefined = entityList.find((entity) => entity.id == params.id);
                        if(result){
                            requestEntitySelected(result);
                            setOpenDialog(false);
                            
                        }
                    }}>
                        <EditIcon fontSize="inherit" />
                </IconButton>
               
                <IconButton aria-label="Delete Document" size="small" color="error" onClick={()=>{ var result:Entity|undefined = entityList.find((entity) => entity.id == params.id);
                    if(result){
                        setEntitySelected(result);
                        setOpenDialog(true);
                    }
                }}>
                    <DeleteIcon fontSize="inherit" />
                </IconButton>
            </div>
            
        )}
];
    
    const requestEntitySelected = (entity:Entity) => {
        setEntitySelected(entity);
        setPage("entityDetails");
    }
    const handleClose = () => {
        setOpen(false);
    };

    const deleteDocument = (doc:Document) => {
        documentService.delete(doc).then(result => {
            setRequestStatus(false);
            setOpen(false);
            
        });
    };

    const handleUpdateProject=  () => {
        projectService.update(projectSelected).then(res => {
            props.backProjectsScreen();
        });
    }

    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
      };


    const backProjectDetails = () => {
        setPage("projectDetails");
    }

    const openDashboard = () =>{
        props.openDashboard(projectSelected);
    }
    const handleSaveChanges = (e:any) => {

        e.preventDefault();

        // Read the form data
        const form = e.target;
        const formData = new FormData(form);

        // You can pass formData as a fetch body directly:
        fetch('/some-api', { method: form.method, body: formData });

        // Or you can work with it as a plain object:
        const formJson = Object.fromEntries(formData.entries());

        projectSelected.name = formJson.Name.toString();
        projectSelected.description = formJson.Description.toString();

        handleUpdateProject();
    };

    /////entiitie list

    
      const handleEntityClose = () => {
        handleLoadEntities(0);
        setOpenDialog(false);
      };

    const handleLoadEntities =  (entityId:number) => {
        var result = entityService.getList(projectSelected.id!);
        result.then(res =>
            {
                const allEntities = res? (res as Entity[]): ([] as Entity[]); 
                setEntityList(allEntities);
                var foundResult = entityList.find((entity) => entity.id == entityId);
                if(foundResult) setEntitySelected(foundResult);
                else
                    setEntitySelected(entityList[0]) 
                //updateDataGrid(entityList);
            });
    
    }

    const filterExistingEntities = async (entityList:Entity[])=>{
            
        var result = entityService.getList(projectSelected.id!);
        await result.then(async res =>
            {
                var newEntities:Entity[] = [];
                const allEntities = res? (res as Entity[]): ([] as Entity[]); 
                const allEntitiesIds = allEntities.map((entity) => entity.Code);
                newEntities = entityList.filter((entity) => !allEntitiesIds.includes(entity.Code));
                 
                await entityService.addSet(newEntities);
            });
    }



    const handleAddEntity = (e:any) => {
        // Prevent the browser from reloading the page
        e.preventDefault();
        // Read the form data
        const form = e.target;
        const formData = new FormData(form);

        // You can pass formData as a fetch body directly:
        fetch('/some-api', { method: form.method, body: formData });

        // Or you can work with it as a plain object:
        const formJson = Object.fromEntries(formData.entries());
        var code = getEntityCode(entityList, projectSelected);
        var newEntity = NewEntity(formJson.entityName.toString(), entityList,code, projectSelected);
        form.reset();
        if(newEntity){
            entityService.add(newEntity).then(res => {
                handleLoadEntities(0);
            });
        }
        
      };


    const handleFileChange = async (e:any) => {
        // Check if user has entered the file
        if (e.target.files.length) {
            const inputFile = e.target.files[0];
            var fileContent = await ReadFileToText(inputFile);
            //var listTmp:Entity[] = ParseEntitiesCSV(fileContent,projectSelected);
            var listTmp:Entity[] = ParseEntitiesJSON(fileContent,projectSelected.id!);
            
            await filterExistingEntities(listTmp);

            handleLoadEntities(0);
        }
    }

    /**
     * Inicializador de carga de un nuevo documento de texto (corpus) para agregar a la lista
     * @param e Evento de selecccion de documento de texto (corpus)
     */
    const handleDocumentFileChange = (e:any) => {
        // Check if user has entered the file
        if (e.target.files.length) {
            var files = e.target.files;
            var resultAll = documentService.getAll();
            resultAll.then(res=> {
                var documentAll = res? (res as Document[]): ([] as Document[]); 
                parseFileService.parseFiles(files,projectSelected.id!, documentAll);
                setTimeout(() => {
                    handleLoadDocuments();
                }, 200);

            });
           
        }
    }

    /**
     * Inicializador de carga de un nuevo documento json (annotaciones) para agregar al projecto
     * @param e Evento de selecccion de documento json (anotaciones)
     */
     const handleAnnotationFileChange = (e:any) => {
        // Check if user has entered the file
        if (e.target.files.length) {
            var files = e.target.files;
            var resultAll = documentService.getList(projectSelected.id!);
            resultAll.then(res=> {
                var documents = res? (res as Document[]): ([] as Document[]); 
                parseFileService.parseAnnotationFiles(files, documents, entityList);
            });
           
        }
    }

    const handleExportEntitiesData = () => {
        exportService.startExportEntitiesData(entityList,projectSelected);
    }

    const handleExportProject = () =>{
        var annotationResult = annotationService.getAllAnnotations();
        annotationResult.then(annotations => { 
            var projectAnnotations =  annotations.filter(ann => 
                documents.find((doc) => doc.id === ann.documentId) !== undefined 
            );
            exportService.exportProject(projectAnnotations,entityList,documents,projectSelected);
         });
    }
    
    return (

        
        <div className="area-tool-container">
            {page === "projectDetails" && 
               <div className="area-entities-header">
                    <div className="area-entities-header-content">
                   <div  className="entity-selected-data-name"><span className="entity-selected-back" onClick={props.backProjectsScreen}>Projects </span><span> / Details</span></div>     
                    </div>
                    <div id="area-corpus-separator" className="separator"></div>
               </div>
            }
            {
                page === "projectDetails" && 
                <div  className="area-entities-content">
                    <Dialog
                    open={open}
                    onClose={handleClose}
                    PaperProps={{
                    component: 'form',
                    onSubmit: (event: React.FormEvent<HTMLFormElement>) => {
                        event.preventDefault();
                        if(documentToDelete){
                            deleteDocument(documentToDelete);
                            
                            handleClose();
                        }
                    },
                    }}
                >
                    <DialogTitle>Delete Document</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                        Do you want to delete the document '{documentToDelete.title}' and its related entries? This action cannot be reversed.
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button type="submit">Delete</Button>
                    </DialogActions>
                </Dialog>

                <Dialog
                        open={openDialog}
                        onClose={handleEntityClose}
                        PaperProps={{
                        component: 'form',
                        onSubmit: (event: React.FormEvent<HTMLFormElement>) => {
                            event.preventDefault();
                            
                            annotationService.getAllAnnotations().then(annotations =>{
                                //Limpiar la primera entidad de la anotaciones que coincidan pasando la segunda a primera
                                var annotationsToMoveSecond = annotations.filter(ann => ann.firstEntityId === entitySelected.id! && ann.secondEntityId !== -1);
                        
                                annotationsToMoveSecond.forEach(annSelected => {
                                    annSelected.firstEntityId =  -1;
                                    annSelected.firstEntityCode = '';
                                    annSelected.fieldsFirstEntity =  [];
                
                                    if(annSelected.secondEntityId >= 0){
                                        annSelected.firstEntityId =  annSelected.secondEntityId;
                                        annSelected.firstEntityCode = annSelected.secondEntityCode;
                                        annSelected.fieldsFirstEntity =  annSelected.fieldsSecondEntity;
                
                                        annSelected.secondEntityId =  -1;
                                        annSelected.secondEntityCode = '';
                                        annSelected.fieldsSecondEntity =  [];
                                    }
                                });

                                //Limpiar la segunda entidad de la anotaciones que coincidan pasando la segunda a primera
                                var annotationsToRemoveSecond = annotations.filter(ann => ann.firstEntityId !== -1 && ann.secondEntityId === entitySelected.id!);
                        
                                annotationsToRemoveSecond.forEach(annSelected => {
                                   
                                    if(annSelected.secondEntityId >= 0){
                                        annSelected.secondEntityId =  -1;
                                        annSelected.secondEntityCode = '';
                                        annSelected.fieldsSecondEntity =  [];
                                    }
                                });
                                 
                                //Limpiar la segunda entidad de las anotaciones que coincidan
                             
                                var annotationsToDelete = annotations.filter(ann => ann.firstEntityId === entitySelected.id! && ann.secondEntityId === -1);
                            
                                var keysToDelete = annotationsToDelete.map(ann => ann.id!);
                                //Borrar entidades de base de datos cuando solo tiene una entidad asignada
                                annotationService.deleteBulk(keysToDelete).then(result => {
                                    //actualizar anotaciones que coincide en segunda entidad

                                    
                                        var resultMoveSecond = annotationService.updateBulk(annotationsToMoveSecond);
                                        resultMoveSecond.then(result => {
                                            
                                            var resultRemoveSecond = annotationService.updateBulk(annotationsToRemoveSecond);
                                            resultRemoveSecond.then(result => {
                                                entityService.delete(entitySelected.id!).then(result => {
                                                    handleEntityClose();
                                                });
                                                    
                                            });
                                        });
                                    

                                    
                                    

                                    
                                }); 
                            });           
                        },
                        }}
                    >
                        <DialogTitle>Delete Entity</DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                            Do you want to delete the entity {(entitySelected)?entitySelected.Entity:''} and its related entries? This action cannot be reversed.
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                        <Button onClick={handleEntityClose}>Cancel</Button>
                        <Button type="submit">Delete</Button>
                        </DialogActions>
                    </Dialog>
                    <div id="entityItemList" className="area-project-item-list">
                        <form  method="post" onSubmit={handleSaveChanges}>
                        
                        <div className="project-selected-buttons">
                            <Button type="submit" variant="contained" color="success">save</Button>
                        </div>
                        <div className="project-selected-buttons-dashboard">
                            <Button variant="contained" color="info" onClick={openDashboard}>DASHBOARD</Button>
                        </div>
                        <div className="project-selected-buttons-export">
                            <Button variant="contained" color="info" onClick={handleExportProject}>EXPORT</Button>
                        </div>

                        <div className="project-selected-information">
                        <TextField
                                    autoFocus
                                    required
                                    margin="dense"
                                    id="Name"
                                    name="Name"
                                    label="Name"
                                    type="text"
                                    fullWidth
                                    variant="standard"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                />
                                <TextareaAutosize
                                maxRows={4}
                                minRows={2}
                                id="Description"
                                name="Description"
                                aria-label="Description"
                                placeholder="Description"
                                className="input-entity-add  input-full"
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                                style={{ minWidth: 400, maxWidth: 800, marginTop: 10 }}
                                />
                            
                        </div>
                        </form>
                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <Tabs value={value} onChange={handleTabChange} aria-label="basic tabs example">
                            <Tab label="Documents" {...a11yProps(0)} />
                            <Tab label="Entities" {...a11yProps(1)} />
                        </Tabs>
                        </Box>
                        <CustomTabPanel value={value} index={0}>
                            <input type="file" onChange={handleDocumentFileChange} name="file-1" id="documentFile" accept=".txt" className="inputfile-document inputfile-document-1"  multiple/>
                            <label htmlFor="documentFile" >
                                <span className="material-symbols-outlined area-documents-add-icon">
                                    Add
                                </span> 
                                <span className="area-documents-add">Add Document</span>
                            </label>
                            
                            <DataGrid apiRef={apiRef} rows={documents} columns={columns} ></DataGrid>
                        </CustomTabPanel>
                        <CustomTabPanel value={value} index={1}>
                        <div className="area-entities-content">
                            <div className="area-entities-inputs">
                                <div className="area-entities-export">
                                     <div className="container-input">
                                    <button type="button" className="button-standard button-standard-success button-entities-export" onClick={handleExportEntitiesData}>Export Entities</button>

                                     </div>
                                </div>
                                <div className="area-entities-manual">
                                    <form method="post" onSubmit={handleAddEntity}>
                                        <input 
                                            id="new-entity-name" 
                                            name="entityName"
                                            className="input-anotador-text input-entity-add" 
                                            type="text"
                                            required
                                            placeholder="Name"/>
                                        <button type="submit" className="button-standard button-standard-success ">Add</button>

                                    </form>

                                </div>
                                <div className="area-entities-import">
                                    <div className="container-input">
                                    <input type="file" onChange={handleFileChange} name="file-1" id="annotationsFile" accept=".json" className={'inputfile-document inputfile-document-1'}  multiple/>
                                    <label htmlFor="annotationsFile" >
                                    <span className={'area-documents-add'}>Import Entities</span>
                                    </label>
                                    </div>
                                </div>

                            </div>
                            <div className="area-entity-container">
                                <div className="area-entity-manager-list">
                                    <DataGrid apiRef={apiEntityRef} rows={entityList} columns={entityColumns} ></DataGrid>
                                </div>
                            </div>
                        </div>
                        </CustomTabPanel>
                    </div>
                </div> 
            }
            {
                page === "entityDetails" && <Details EntitySelected={entitySelected} EntityList={entityList} Project={projectSelected} backHomeScreen={props.backProjectsScreen} backProjectScreen={backProjectDetails} />
            }

            
        </div>
    


   
      
    )
}

